var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6429 7.08956H4.07143L8.53643 2.42537C8.66363 2.29358 8.7646 2.13678 8.8335 1.96402C8.9024 1.79126 8.93787 1.60596 8.93787 1.41881C8.93787 1.23166 8.9024 1.04636 8.8335 0.873601C8.7646 0.700843 8.66363 0.544045 8.53643 0.412253C8.28215 0.148207 7.93818 0 7.57964 0C7.22111 0 6.87714 0.148207 6.62286 0.412253L0.800715 6.50831C0.290988 7.0376 0.00303021 7.75648 0 8.50725C0.00660465 9.2531 0.294289 9.9662 0.800715 10.492L6.62286 16.5881C6.7494 16.7193 6.89944 16.8233 7.06443 16.8939C7.22942 16.9646 7.40612 17.0006 7.58444 17C7.76276 16.9993 7.93922 16.962 8.10372 16.8901C8.26823 16.8182 8.41757 16.7132 8.54322 16.581C8.66886 16.4488 8.76836 16.2921 8.83601 16.1197C8.90367 15.9474 8.93817 15.7628 8.93754 15.5765C8.93691 15.3902 8.90116 15.2059 8.83234 15.0341C8.76352 14.8622 8.66297 14.7062 8.53643 14.575L4.07143 9.92494H17.6429C18.0028 9.92494 18.348 9.77557 18.6025 9.50971C18.857 9.24384 19 8.88324 19 8.50725C19 8.13126 18.857 7.77066 18.6025 7.50479C18.348 7.23893 18.0028 7.08956 17.6429 7.08956Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.fab8140f64db0bfbeab236eb703847aa.svg";
export { ForwardRef as ReactComponent };